export default __webpack_public_path__ + "static/media/Wt_Quantity.2f87d156.svg";